import styled from 'styled-components';
import WithDirection from "../../../../config/withDirection";

const StyleWrapper = styled.div`
    .summary-title { margin-bottom: 21px; }

    .screenshots {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-column-gap: 3px;
        margin-bottom: 26px;
    }
    .screenshots img { max-width: 100%; }

    .grid-container {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: 6px;
        grid-row-gap: 3px;
    }

    @media screen and (max-width: 767px) {
        .screenshots { display: block; padding: 0 17px; }
        .screenshots .shot-bubbles { display: flex; justify-content: center; margin-top: 21px; }
        .screenshots .shot-bubble {
            margin: 0 6px;
            display: inline-block;
            width: 6px; height: 6px;
            background-color: rgba(219, 219, 219, 1);
            border-radius: 6px;
            transition: .3s;
        }
        .screenshots .activated-shot-bubble { background-color: rgba(60, 211, 207, 1); }

        .grid-container { grid-template-columns: 100%; }
        
        .grid-container > *:nth-child(4) { grid-row: 2; }
        .grid-container > *:nth-child(7) { grid-row: 3; }
        
        .grid-container > *:nth-child(5) { grid-row: 5; }
        .grid-container > *:nth-child(8) { grid-row: 6; }
        
        .grid-container > *:nth-child(6) { grid-row: 8; }
        .grid-container > *:nth-child(9) { grid-row: 9; }
    }
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/GridGraphics/Wrapper.js